// extracted by mini-css-extract-plugin
export default {"overlay":"Preloader_overlay__0V765","loader":"Preloader_loader__V8dXg","rotation":"Preloader_rotation__wKhK6"};